import type { EvaluationTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { FeedbackPrivacyValue } from '@/constants/review/FeedbackPrivacy';
import type { User } from '@/types/directory/User';
import type { ReactNode } from 'react';

import { EvaluationResultInformation } from '@/components/EvaluationResultInformation/EvaluationResultInformation';

export interface ResultsHeaderProps {
    employeeName: string;
    employeeRole: string;
    evaluationLabel: string;
    invitedCount: number;
    respondedCount: number;
    reviewers: User[];
    dateLabel?: string;
    reviewType?: EvaluationTypeValue;
    feedbackPrivacy?: FeedbackPrivacyValue;
    commentRepliesEnabled?: boolean;
    minimumResponses?: number;
    status?: ReactNode;
    className?: string;
}

export const ResultsHeader = ({
    employeeName,
    employeeRole,
    evaluationLabel,
    invitedCount,
    respondedCount,
    reviewers,
    dateLabel,
    reviewType,
    feedbackPrivacy,
    commentRepliesEnabled,
    minimumResponses,
    status,
    className = '',
}: ResultsHeaderProps) => {
    return (
        <div className={`md:w-3/4 lg:w-1/2 ${className}`}>
            <EvaluationResultInformation
                employeeName={employeeName}
                employeeRole={employeeRole}
                evaluationLabel={evaluationLabel}
                invitedCount={invitedCount}
                respondedCount={respondedCount}
                reviewers={reviewers}
                dateLabel={dateLabel}
                reviewType={reviewType}
                feedbackPrivacy={feedbackPrivacy}
                commentRepliesEnabled={commentRepliesEnabled}
                minimumResponses={minimumResponses}
                status={status}
                dataTestId={'results-header'}
            />
        </div>
    );
};

export default ResultsHeader;
